import { createContext, useContext, useState, useEffect, useCallback } from "react";

const ThemeContext = createContext(null);
export const THEMES = ["dark", "black", "light"];

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("jp-theme");
    return THEMES.includes(saved) ? saved : "dark";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark", "light", "black");
    if (theme === "black") root.classList.add("dark", "black");
    else root.classList.add(theme);
    localStorage.setItem("jp-theme", theme);
  }, [theme]);

  const toggle = useCallback(
    () => setTheme((t) => THEMES[(THEMES.indexOf(t) + 1) % THEMES.length]),
    []
  );

  return <ThemeContext.Provider value={{ theme, setTheme, toggle }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
